module.exports = __webpack_public_path__ + "t_workstyle_concierge-2.png?279d42baca4c7d4dd8207bf08cc37238";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t_workstyle_concierge-2.png
// module id = 844
// module chunks = 0